import React, {Fragment,useState,useEffect,useContext} from 'react';
import * as Icon from '../../FinanceIcons/FinanceIcons';
import {ClipLoader} from 'react-spinners';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import Tile from '../../Tile/Tile';
import Button from '../../Button/Button';
import PageHeader from '../../PageHeader/PageHeader';
import {ProgressState} from '../../../styles/commons';
import Progress from '../../../stacks/progress/ProgressAWS';
import {useErrorToast} from '../../../hooks/useErrorToast';
import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
import {ProgressesStatus} from '../../../context';

const Roadmap = props => {
  const {setErrorMsg,errorToast} = useErrorToast('');
  const [progressState, setProgressState] = useState({});
  const [questionaireCompleted,setQuestionaireCompleted] = useState(false);
  const [completing, setCompleting] = useState(false)
  const [operators] = useState({
    '+' : (a,b) => a + b,
    '-' : (a,b) => a - b,
    '=' : (a,b) => a === b,
    '!=' : (a,b) => a !== b,
    '<' : (a,b) => a < b, 
    '>' : (a,b) => a > b
  })

  const progress = useContext(ProgressesStatus);

  const {
    sections=[],
    answers={},
    pathBase,
    progresses,
    home
  } = props;

  const sectionsx = [
    {title:'Section 1',component:<Icon.Finance1/>},
    {title:'Section 2',component:<Icon.Finance2/>},
    {title:'Section 3',component:<Icon.Finance3/>},
    {title:'Section 4',component:<Icon.Finance4/>},
    {title:'Section 5',component:<Icon.Finance5/>},
    {title:'Section 6',component:<Icon.Finance6/>},
    {title:'Section 7',component:<Icon.Finance7/>},
    {title:'Section 8',component:<Icon.Finance8/>},
    {title:'Section 9',component:<Icon.Finance9/>},
    {title:'Section 10',component:<Icon.Finance10/>},
    {title:'Section 11',component:<Icon.Finance11/>},
    {title:'Section 12',component:<Icon.Finance12/>},
    {title:'Section 13',component:<Icon.Finance13/>},
    {title:'Section 14',component:<Icon.Finance14/>},
    {title:'Section 15',component:<Icon.Finance15/>},
    {title:'Section 16',component:<Icon.Finance16/>}
  ];

  useEffect(() => {
    function checkComplete(key) {
      // console.log('key',key);
      const thisSection = sections.find(item => item.key === key)
      const questions = thisSection.questions
      const keyIndex = thisSection.keyIndex
  
      let notCompleted = 0;
      for (let item of questions) {
        const thisAnswer = answers[item.key]
        if (!item.condition) {
          if (thisAnswer === undefined) {
            notCompleted++
          }
        } else {
          const {lhs,operator:o,rhs} = item.condition;
          let lhsAnswer = undefined
          if (lhs === 'prefix') {
            if (keyIndex && keyIndex !== '' && keyIndex.length > 1) {
              lhsAnswer = keyIndex.charAt(1) // Ex: -P0 is 'P'
            }
          } else {
            lhsAnswer = answers[`${lhs}${keyIndex}`]
            // Answer might be in a different non-repeating section
            lhsAnswer = lhsAnswer ? lhsAnswer : answers[lhs] 
          }
  
          if (lhsAnswer !== undefined) {
            const conditionMet = operators[o || '='](lhsAnswer,rhs);
            if (conditionMet && thisAnswer === undefined) {
              notCompleted++
            } 
          }
        }
      }
      // console.log('count:',notCompleted);
      return notCompleted;
    };
  
    if (sections.length === 0) {
      return
    }
    const progress = {};
    sections.forEach(({key}) => progress[key] = checkComplete(key));

    setProgressState(progress);

    let qCompleted = true;
    for (let key in progress) {
      if (progress[key] !== 0) {
        qCompleted = false;
      }
    }
    setQuestionaireCompleted(qCompleted);

  },[sections, answers, operators]);


  function renderProgress(value) {
    if (value) {
      return <ProgressState progress='notStarted'>{`${value} REQUIRED`}</ProgressState>;
    }
    return <ProgressState progress='completed'>COMPLETED</ProgressState>;
  }


  function complete() {
    const progressApi = Progress.getInstance();

    progressApi.store({[progresses]: 'completed'})
    .then((data) => {
      progress.update(data.progresses)
      props.history.push(home)
    })
    .catch((err) => {
      setErrorMsg(`Questionnaire complete error: ${JSON.stringify(err,null,2)}`);
      console.error(`Questionnaire complete error: ${JSON.stringify(err,null,2)}`)
    })
  }

  const sectionTiles = sections.map((item,i) => (
    <Col key={`section_${i}`} lg={3}>
      <Tile
        link={`/${pathBase}/${item.key}`}
        title={item.title}
      >
        {sectionsx[i % sectionsx.length].component}<br/>
        {renderProgress(progressState[item.key])}
      </Tile>
    </Col>
  ));



  return (
    <Fragment>
      <PageHeader title='Questionnaire'>
        <div style={{textAlign: 'right'}}>
          <Button
            small
            color='#28b536'
            click={() => setCompleting(true)}
            disabled={!questionaireCompleted}
          >
            COMPLETE
          </Button>
        </div>

      </PageHeader>
      <Container>
        <Row>
          <Col>
            <p>Complete each section in any order. You may leave the sections and return to complete at another time. Hit the Complete button above when you are all done.</p>
          </Col>
        </Row>
          {props.loading ? (
            <div style={{textAlign:'center'}}>
              <ClipLoader
                color='blue'
                loading={props.loading}
              />
              <p>Loading sections...</p>
            </div>
          ) : (
            <Row>
              {sectionTiles}
            </Row>
          )}
      </Container>
      {completing && (
        <ConfirmationModal
          cancel={() => setCompleting(false)}
          confirm={() => complete()}
          confirmationBtnTitle='COMPLETE'
        >
        Thank you for completing the current scene questionnaire.
        </ConfirmationModal>
      )}
      {errorToast}
    </Fragment>
  );
};

export default Roadmap;
